module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: (_vm.alterDateModal),
      callback: function($$v) {
        _vm.alterDateModal = $$v
      },
      expression: "alterDateModal"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "mt-2 mb-2 headline"
  }, [_vm._v("Atenção")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.alterDateModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Insira um motivo para a alteração da data")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": false,
      "row": "",
      "pa-3": ""
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }, _vm._l((_vm.reasons), function(reason) {
    return _c('v-radio', {
      key: reason.id,
      attrs: {
        "color": "red",
        "label": reason.description,
        "value": reason.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.alterSchedule($event)
      }
    }
  }, [_vm._v("Sim, desejo alterar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ead04c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/AlterDateWarning.vue
// module id = 502
// module chunks = 0 1